import { ITheme } from '../types'

export const defaultTheme: ITheme = {
  color: {
    textLight: '#51C8E8',
    white: 'white',
    black: 'black',
    textDark: '#01728f',
    lightGrey: '#eeeeee',
    primaryDark: '#01728f',
    primaryDarker: '#01728f',
  },
  button: {
    sizes: {
      small: {
        fontSize: '14px',
        height: '30px',
        padding: '0 8px',
      },
      medium: {
        fontSize: '16px',
        height: '40px',
        padding: '0 12px',
      },
      large: {
        fontSize: '18px',
        height: '50px',
        padding: '0 16px',
      },
    }
  },
  fontSize: {
    small: '9px',
    medium: '14px',
    large: '18px',
    xlarge: '20px'
  },
  breakpoint: {
    mini: '125px',
    small: '610px',
    medium: '830px', // not used
    large: '960px',
    footer: '670px',
    modalLarge: '1500px'
  },
  navbar: {
    height: {
      short: '65px',
      tall: '165px'
    }
  }
}



// WEBPACK FOOTER //
// ./src/theme/defaultTheme.ts